import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function ReminderBell() {
  const [d, setD] = useState({ items: [], unread: 0 });
  const load = () => api.get("/reminders").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, []);
  const readAll = async () => { await api.post("/reminders/read-all"); load(); };
  const readOne = (id) => api.post(`/reminders/${id}/read`).then(load);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="reminder-bell" className="relative p-2 rounded hover:bg-slate-100 text-slate-600" title="Review reminders">
          <Bell size={16} />
          {d.unread > 0 && <span data-testid="reminder-unread-count" className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white">{d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-white p-0" data-testid="reminder-panel">
        <div className="flex items-center justify-between border-b border-slate-100 px-3 py-2">
          <span className="text-[13px] font-semibold">Review reminders</span>
          {d.unread > 0 && <button data-testid="reminder-read-all" onClick={readAll} className="text-[11px] font-semibold text-sky-700">Mark all read</button>}
        </div>
        <ul className="max-h-80 overflow-auto">
          {d.items.map((r) => (
            <li key={r.id} className={`border-b border-slate-100 px-3 py-2 text-[12px] ${r.read ? "" : "bg-red-50/60"}`} data-testid={`reminder-${r.id}`}>
              <Link to={`/protocols/${r.protocol_id}`} onClick={() => readOne(r.id)} className="font-semibold text-slate-900 hover:text-sky-700">{r.title} v{r.version}</Link>
              <div className="text-red-700">Clinical review overdue by {r.days_overdue} day(s) · due {r.next_review_due}</div>
              <div className="text-[10px] text-slate-400">{r.date}</div>
            </li>
          ))}
          {!d.items.length && <li className="px-3 py-4 text-[12px] text-slate-500">No reminders.</li>}
        </ul>
        <div className="px-3 py-2 text-[10px] text-slate-400">Sent daily at 9:00 IST{d.last_run ? ` · last run ${d.last_run.ts.slice(0, 16).replace("T", " ")} UTC` : ""}</div>
      </PopoverContent>
    </Popover>
  );
}
